import { render } from "./SuppliesModal.vue?vue&type=template&id=2ab4caa4"
import script from "./SuppliesModal.vue?vue&type=script&lang=js"
export * from "./SuppliesModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn});
